module.exports = __webpack_public_path__ + "img/successful-college-student-lg.c72cb17e.png";